export default () => ({
    patientErrorSection: {
        marginBottom: '2.5rem',
        '& .MuiList-root': {
            padding: 0,
        },
    },
    patientErrorSectionTitle: {
        fontWeight: 'bold',
        marginBottom: '1rem',
        paddingBottom: '.05rem',
        borderBottom: '1px solid #ECECEC',
    },
    patientErrorSectionListItem: {
        marginBottom: '1rem',
        padding: 0,
    },
    patientErrorDialogTitle: {
        '& .MuiTypography-root': {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
    },
    patientErrorDialogTitleIcon: {
        marginRight: '1rem',
        height: '2.4rem',
        width: '2.4rem',
        fill: '#fb3323',
    },
    patientErrorDialogTitleText: {
        fontSize: '1.4em',
    },
})
